<template>
  <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.1374 0.087115L15.1468 2.49762L15.1684 4.79111" stroke="currentColor"/>
    <path d="M12.8008 2.43921H17.5049" stroke="currentColor"/>
    <path d="M4.93764 13.8035C1.15339 8.01631 0.451172 7.42208 0.451172 5.29578C0.467891 3.90831 1.00203 2.58365 1.9379 1.60873C2.87376 0.633821 4.13599 0.0871582 5.45117 0.0871582C6.76635 0.0871582 8.02858 0.633821 8.96445 1.60873C9.90031 2.58365 10.4345 3.90831 10.4512 5.29578C10.4512 7.42293 9.74895 8.01631 5.96471 13.8044C5.90704 13.8917 5.8302 13.9631 5.74074 14.0123C5.65128 14.0616 5.55186 14.0872 5.45096 14.0872C5.35006 14.0871 5.25068 14.0612 5.16129 14.0118C5.0719 13.9625 4.99517 13.891 4.93764 13.8035ZM5.45158 7.49454C5.86353 7.49438 6.26619 7.36535 6.60865 7.12377C6.95112 6.8822 7.218 6.53892 7.37558 6.13734C7.53315 5.73576 7.57434 5.2939 7.49393 4.86763C7.41352 4.44135 7.21513 4.0498 6.92384 3.74247C6.63254 3.43513 6.26142 3.22582 5.85738 3.14099C5.45335 3.05615 5.03455 3.09961 4.65392 3.26585C4.27329 3.4321 3.94793 3.71368 3.71896 4.075C3.48999 4.43631 3.3677 4.86114 3.36754 5.29578C3.36754 5.58448 3.42145 5.87036 3.52619 6.13708C3.63093 6.4038 3.78445 6.64613 3.97799 6.85024C4.17152 7.05435 4.40127 7.21622 4.65411 7.32663C4.90695 7.43704 5.17793 7.49466 5.45158 7.49454Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconPresetOwn',
  }
</script>

<style scoped>

</style>
